/** @ngInject */
function fallbackSrcFn(DEFAULT_IMG, ENV) {
	const defaultFallback = DEFAULT_IMG;
	var directive = {
		restrict: 'A',
		scope: {fallbackSrc: '@'},
		link: link,
	};
	return directive;
	function link(scope, element) {
		element.on('error', function (e) {
			if (ENV !== 'production') console.log(e.target); // eslint-disable-line
			var fallback = scope.fallbackSrc || defaultFallback;
			element.attr('src', fallback);
		});
	}
}
// fallback-src
export default angular.module('mod.drt.fallbackSrc', []).directive('fallbackSrc', fallbackSrcFn).name;
